import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { ExpensesApi } from '../expenses.api';

export const useGetCalculationsOnProductExpansesUpdate = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: ExpensesApi.getExpensesByProduct,
  });
};
